// extracted by mini-css-extract-plugin
export default {"yes_no_popup":"YesNoPopup_yes_no_popup__+dNvW","buttonContainer":"YesNoPopup_buttonContainer__+dOCi"};